export default "__VITE_ASSET__uFq3_803__"